export const APP_ROUTES = {
    basename: '/career',
    customerShifts: '/customer/*',
    candidateAvailability: (token: string) => `/availability_for_period/${ token }`,
    candidateOffers: '/candidate/offers',
    requestForOpportunities: '/candidate/request_for_opportunities',
    preferences: '/preferences',
    preferencesEdit: '/preferences/edit',
    aiAssistant: '/ai-assistant',
    profile: '/profile',
    profileEdit: '/profile/edit',
    myJobs: '/my-jobs',
    jobDetails: (id: string) => `/my-jobs/${ id }`,
    contacts: '/contacts'
} as const;
